<template>
  <div
    class="flex flex-row items-center rounded-md bg-neutral-100"
    :class="size === 'sm' ? 'gap-1 p-0.5' : 'gap-2 p-1'"
  >
    <button
      v-for="option in options"
      :key="String(option.value)"
      type="button"
      :aria-pressed="modelValue === option.value"
      class="flex-1 rounded-md font-medium transition-[color,background-color,box-shadow] duration-150 ease-out-quart"
      :class="[
        size === 'sm' ? 'px-3 py-1 text-xs' : 'px-4 py-2 text-sm',
        modelValue === option.value ? 'bg-white text-primary-500 shadow-sm' : 'text-neutral-500 hover:text-neutral-700'
      ]"
      @click="emit('update:modelValue', option.value)"
    >
      {{ typeof option.label === 'function' ? option.label() : t(option.label) }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

interface SegmentedOption {
  value: string | boolean;
  label: string | (() => string);
}

interface Props {
  modelValue: string | boolean;
  options: SegmentedOption[];
  size?: 'sm' | 'base';
}

withDefaults(defineProps<Props>(), { size: 'base' });

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | boolean): void;
}>();

const { t } = useI18n();
</script>
